<template>
  <div>
    <div class="content">
      <div class="headBox">
        <div
          class="name"
          :class="index == typeOn ? 'on' : ''"
          v-for="(item, index) in typeList"
          @click="typeClick(index)"
        >
          {{ item }}
        </div>
      </div>
      <div v-if="typeOn == 0">
        <Gszc />
      </div>
      <!-- <div v-if="typeOn == 1">
        <GsChengyuan />
      </div> -->
    </div>
  </div>
</template>

<script>
import {
  Document,
  Packer,
  Paragraph,
  TextRun,
  AlignmentType,
  Table,
  TableRow,
  TableCell,
  ImageRun,
  BorderStyle,
  VerticalAlign,
  HeightRule,
} from "docx";
import { saveAs } from "file-saver";
import GsChengyuan from "./gsChengyuan.vue";
import Gszc from "../../login/zcGs.vue";
export default {
  components: {
    Gszc,
    GsChengyuan,
  },
  name: "",
  data() {
    return {
      avatarBase64: "https://suzkj.com/static/avatar/tx2.png",
      judge: true,
      page: {
        pageNo: 1,
        pageSize: 30,
      },
      list: [],
      totalCount: 0,
      quanxian: false,
      typeOn: 0,
      typeList: ["公司基本资料管理"],
    };
  },
  created() {},
  methods: {
    phoFz(text) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      this.$message.success("复制成功");
    },
    getBase64Image(imgUrl) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.src = imgUrl;
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          const dataURL = canvas.toDataURL("image/png");
          resolve(dataURL);
        };
        img.onerror = (error) => reject(error);
      });
    },
    async generateResumeDocument() {
      try {
        const imageBase64 = await this.getBase64Image(this.avatarBase64);
        // 创建文档
        const doc = new Document({
          sections: [
            {
              children: [
                // 头像段落
                new Paragraph({
                  children: [
                    new ImageRun({
                      data: imageBase64,
                      transformation: { width: 100, height: 100 },
                    }),
                  ],
                  alignment: AlignmentType.CENTER,
                  spacing: { after: 200 }, // 增加头像与其他内容的间距
                }),

                // 姓名段落
                new Paragraph({
                  children: [
                    new TextRun({
                      text: "林传博",
                      bold: true,
                      size: 28,
                      color: "000000", // 蓝色字体
                    }),
                  ],
                  alignment: AlignmentType.CENTER,
                  spacing: { after: 100 }, // 姓名与联系方式之间的间距
                }),

                // 联系方式段落
                new Paragraph({
                  children: [
                    new TextRun("电话: 15868653801 、 "),
                    new TextRun("邮箱: johndoe@example.com 、 "),
                    new TextRun("性别: 男 、 "),
                    new TextRun("籍贯: 台州"),
                  ],
                  alignment: AlignmentType.CENTER,
                  spacing: { after: 200 }, // 增加与下部分内容的间距
                }),

                // 求职意向标题
                new Paragraph({
                  children: [
                    new TextRun({
                      text: "求职意向",
                      bold: true,
                      size: 28,
                    }),
                  ],
                  alignment: AlignmentType.LEFT,
                  spacing: { after: 100 }, // 增加标题与内容的间距
                }),

                // 求职意向内容
                new Table({
                  rows: [
                    // 表头
                    new TableRow({
                      children: [
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({ text: "\n", size: 16 }), // 插入空白段落拉升行高
                              ],
                              spacing: { after: 0 },
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({ text: "期望职位", size: 20 }),
                              ],
                              alignment: AlignmentType.CENTER, // 左右居中
                              spacing: { after: 0 },
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({ text: "\n", size: 16 }), // 插入空白段落拉升行高
                              ],
                              spacing: { after: 0 },
                            }),
                          ],
                          verticalAlign: VerticalAlign.CENTER, // 垂直居中
                          height: { value: 6000, rule: HeightRule.EXACT }, // 强制固定高度为6000 Twips
                        }),
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({ text: "\n", size: 16 }), // 插入空白段落拉升行高
                              ],
                              spacing: { after: 0 },
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({ text: "期望行业", size: 20 }),
                              ],
                              alignment: AlignmentType.CENTER, // 左右居中
                              spacing: { after: 0 },
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({ text: "\n", size: 16 }), // 插入空白段落拉升行高
                              ],
                              spacing: { after: 0 },
                            }),
                          ],
                          verticalAlign: VerticalAlign.CENTER,
                          height: { value: 6000, rule: HeightRule.EXACT }, // 强制固定高度为6000 Twips
                        }),
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({ text: "\n", size: 16 }), // 插入空白段落拉升行高
                              ],
                              spacing: { after: 0 },
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({ text: "期望地点", size: 20 }),
                              ],
                              alignment: AlignmentType.CENTER, // 左右居中
                              spacing: { after: 0 },
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({ text: "\n", size: 16 }), // 插入空白段落拉升行高
                              ],
                              spacing: { after: 0 },
                            }),
                          ],
                          verticalAlign: VerticalAlign.CENTER,
                          height: { value: 6000, rule: HeightRule.EXACT }, // 强制固定高度为6000 Twips
                        }),
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({ text: "\n", size: 16 }), // 插入空白段落拉升行高
                              ],
                              spacing: { after: 0 },
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({ text: "期望薪资", size: 20 }),
                              ],
                              alignment: AlignmentType.CENTER, // 左右居中
                              spacing: { after: 0 },
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({ text: "\n", size: 16 }), // 插入空白段落拉升行高
                              ],
                              spacing: { after: 0 },
                            }),
                          ],
                          verticalAlign: VerticalAlign.CENTER,
                          height: { value: 6000, rule: HeightRule.EXACT }, // 强制固定高度为6000 Twips
                        }),
                      ],
                    }),
                    new TableRow({
                      children: [
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({ text: "\n", size: 16 }), // 插入空白段落拉升行高
                              ],
                              spacing: { after: 0 },
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({ text: "期望职位", size: 16 }),
                              ],
                              alignment: AlignmentType.CENTER, // 左右居中
                              spacing: { after: 0 },
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({ text: "\n", size: 16 }), // 插入空白段落拉升行高
                              ],
                              spacing: { after: 0 },
                            }),
                          ],
                          verticalAlign: VerticalAlign.CENTER, // 垂直居中
                          height: { value: 6000, rule: HeightRule.EXACT }, // 强制固定高度为6000 Twips
                        }),
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({ text: "\n", size: 16 }), // 插入空白段落拉升行高
                              ],
                              spacing: { after: 0 },
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({ text: "期望行业", size: 16 }),
                              ],
                              alignment: AlignmentType.CENTER, // 左右居中
                              spacing: { after: 0 },
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({ text: "\n", size: 16 }), // 插入空白段落拉升行高
                              ],
                              spacing: { after: 0 },
                            }),
                          ],
                          verticalAlign: VerticalAlign.CENTER,
                          height: { value: 6000, rule: HeightRule.EXACT }, // 强制固定高度为6000 Twips
                        }),
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({ text: "\n", size: 16 }), // 插入空白段落拉升行高
                              ],
                              spacing: { after: 0 },
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({ text: "期望地点", size: 16 }),
                              ],
                              alignment: AlignmentType.CENTER, // 左右居中
                              spacing: { after: 0 },
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({ text: "\n", size: 16 }), // 插入空白段落拉升行高
                              ],
                              spacing: { after: 0 },
                            }),
                          ],
                          verticalAlign: VerticalAlign.CENTER,
                          height: { value: 6000, rule: HeightRule.EXACT }, // 强制固定高度为6000 Twips
                        }),
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({ text: "\n", size: 16 }), // 插入空白段落拉升行高
                              ],
                              spacing: { after: 0 },
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({ text: "期望薪资", size: 16 }),
                              ],
                              alignment: AlignmentType.CENTER, // 左右居中
                              spacing: { after: 0 },
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({ text: "\n", size: 16 }), // 插入空白段落拉升行高
                              ],
                              spacing: { after: 0 },
                            }),
                          ],
                          verticalAlign: VerticalAlign.CENTER,
                          height: { value: 6000, rule: HeightRule.EXACT }, // 强制固定高度为6000 Twips
                        }),
                      ],
                    }),
                  ],
                  width: { size: 100, type: "pct" }, // 设置表格宽度为100%
                  spacing: { after: 200 },
                }),

                // 工作经历标题
                new Paragraph({
                  children: [
                    new TextRun({
                      text: "Work Experience",
                      bold: true,
                      size: 28,
                    }),
                  ],
                  alignment: AlignmentType.LEFT,
                  spacing: { after: 100 },
                }),

                // 工作经历表格
                new Table({
                  rows: [
                    // 表头
                    new TableRow({
                      children: [
                        new TableCell({
                          children: [new Paragraph("Company")],
                          borders: {
                            top: { style: BorderStyle.NONE },
                            bottom: { style: BorderStyle.SINGLE },
                          },
                        }),
                        new TableCell({
                          children: [new Paragraph("Position")],
                          borders: {
                            top: { style: BorderStyle.NONE },
                            bottom: { style: BorderStyle.SINGLE },
                          },
                        }),
                        new TableCell({
                          children: [new Paragraph("Duration")],
                          borders: {
                            top: { style: BorderStyle.NONE },
                            bottom: { style: BorderStyle.SINGLE },
                          },
                          alignment: AlignmentType.RIGHT, // 右对齐时间
                        }),
                      ],
                    }),
                    // 第一行工作经历
                    new TableRow({
                      children: [
                        new TableCell({
                          children: [new Paragraph("Tech Corp")],
                        }),
                        new TableCell({
                          children: [new Paragraph("Software Engineer")],
                        }),
                        new TableCell({
                          children: [new Paragraph("2019 - Present")],
                          alignment: AlignmentType.RIGHT,
                        }),
                      ],
                    }),
                    // 第二行工作经历
                    new TableRow({
                      children: [
                        new TableCell({
                          children: [new Paragraph("Code Factory")],
                        }),
                        new TableCell({
                          children: [new Paragraph("Junior Developer")],
                        }),
                        new TableCell({
                          children: [new Paragraph("2017 - 2019")],
                          alignment: AlignmentType.RIGHT,
                        }),
                      ],
                    }),
                  ],
                  width: { size: 100, type: "pct" }, // 设置表格宽度为100%
                }),

                // 技能部分
                new Paragraph({
                  children: [
                    new TextRun({
                      text: "Skills",
                      bold: true,
                      size: 28,
                      underline: { type: "single" },
                    }),
                  ],
                  alignment: AlignmentType.LEFT,
                  spacing: { before: 200, after: 100 },
                }),
                new Paragraph({
                  children: [
                    new TextRun({
                      text: "• JavaScript, TypeScript, Vue.js, Node.js\n• HTML5, CSS3, Sass\n• Git, Docker, AWS",
                      size: 24,
                    }),
                  ],
                  alignment: AlignmentType.LEFT,
                }),
              ],
            },
          ],
        });

        // 生成并下载 Word 文档
        const buffer = await Packer.toBlob(doc);
        saveAs(buffer, "resume.docx");
      } catch (error) {
        console.error(
          "An error occurred while generating the Word document:",
          error
        );
        alert(
          "An error occurred while generating the document. Please try again."
        );
      }
    },
    typeClick(i) {
      this.typeOn = i;
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.content {
  margin: auto;
  margin-top: 15px;
  border-radius: 10px;
  height: calc(100vh - 85px);
  width: 1280px;
  .headBox {
    display: flex;
    align-items: center;
    // justify-content: space-between;
    height: 50px;
    padding: 0 20px;
    .name {
      font-size: 20px;
      color: #888;
      margin-right: 40px;
      cursor: pointer;
    }
    .name:hover{
      color: #000;
      font-weight: 600;
    }
    .on {
      font-weight: 600;
      color: #000;
      font-size: 20px;
    }
    .cont {
      display: flex;
      align-items: center;
      .box {
        margin-left: 20px;
        border-radius: 5px;
        background-color: #eef4fc;
        height: 35px;
        width: 150px;
        display: flex;
        align-items: center;
        cursor: pointer;
        .text {
          width: calc(100% - 20px);
          padding-left: 12px;
          box-sizing: border-box;
        }
        .iconfont {
          font-size: 12px;
        }
      }
    }
  }
}
</style>
